import { useState } from 'react';

export default function Scenarios() {
  const [activeIndex, setActiveIndex] = useState(0);

  const scenarios = [
    {
      title: '夜间安防巡逻',
      status: '进行中',
      online: '3架在线',
      image: 'https://public.readdy.ai/ai/img_res/38e21a2a273213afaacc65e4649b690c.jpg',
      time: '23:45',
      location: '3号码头',
      altitude: '120m'
    },
    {
      title: '堆场盘点作业',
      status: '进行中',
      online: '5架在线',
      image: 'https://readdy.ai/api/search-image?query=lidar%20point%20cloud%20scanning%20of%20cargo%20stacks%2C%203D%20laser%20scan%20visualization%20of%20container%20yard%2C%20colorful%20point%20cloud%20data%20of%20port%20storage%20area%2C%20automated%20inventory%20counting%20system%2C%20technical%20scanning%20interface%20overlay&width=800&height=600&seq=scenario-002&orientation=landscape',
      time: '14:20',
      location: '散货堆场A区',
      altitude: '80m'
    },
    {
      title: '船舶靠泊辅助',
      status: '进行中',
      online: '2架在线',
      image: 'https://readdy.ai/api/search-image?query=aerial%20drone%20view%20assisting%20large%20cargo%20ship%20docking%2C%20bird%20eye%20perspective%20of%20vessel%20approaching%20berth%2C%20real-time%20navigation%20assistance%20with%20distance%20markers%2C%20maritime%20operations%20from%20above%2C%20blue%20ocean%20and%20port%20terminal&width=800&height=600&seq=scenario-003&orientation=landscape',
      time: '09:15',
      location: '5号泊位',
      altitude: '150m'
    },
    {
      title: '航道巡检',
      status: '进行中',
      online: '2架在线',
      image: 'https://readdy.ai/api/search-image?query=drone%20inspecting%20navigation%20channel%20and%20buoys%2C%20aerial%20view%20of%20shipping%20lane%20with%20navigation%20markers%2C%20maritime%20safety%20inspection%20from%20above%2C%20waterway%20monitoring%20with%20AI%20recognition%20overlay%2C%20clear%20blue%20water%20and%20navigation%20aids&width=800&height=600&seq=scenario-004&orientation=landscape',
      time: '11:30',
      location: '主航道',
      altitude: '100m'
    }
  ];

  return (
    <section id="scenarios" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        {/* 标题 */}
        <div className="flex items-start justify-between mb-12">
          <div className="inline-block px-4 py-2 border border-teal-500 rounded-full">
            <span className="text-teal-400 text-sm tracking-widest">REAL-TIME SCENARIOS</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white">
            实时作业场景
          </h2>
        </div>

        {/* 场景卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {scenarios.map((scenario, index) => (
            <div
              key={index}
              className={`group cursor-pointer transition-all duration-300 ${
                activeIndex === index ? 'scale-105' : 'hover:scale-105'
              }`}
              onClick={() => setActiveIndex(index)}
            >
              {/* 图片区域 */}
              <div className="relative w-full h-64 rounded-lg overflow-hidden mb-4">
                <img 
                  src={scenario.image} 
                  alt={scenario.title}
                  className="w-full h-full object-cover"
                />
                
                {/* 数据标签叠加 */}
                <div className="absolute top-4 left-4 right-4 flex justify-between">
                  <div className="px-3 py-1 bg-black/70 backdrop-blur-sm rounded-full text-xs text-white">
                    {scenario.time}
                  </div>
                  <div className="px-3 py-1 bg-black/70 backdrop-blur-sm rounded-full text-xs text-white">
                    {scenario.altitude}
                  </div>
                </div>
                <div className="absolute bottom-4 left-4">
                  <div className="px-3 py-1 bg-black/70 backdrop-blur-sm rounded-full text-xs text-white">
                    <i className="ri-map-pin-line mr-1"></i>
                    {scenario.location}
                  </div>
                </div>
              </div>

              {/* 信息区域 */}
              <div>
                <h3 className="text-xl font-bold text-white mb-2">
                  {scenario.title}
                </h3>
                <div className="flex items-center gap-3 text-sm">
                  <span className="text-teal-400">{scenario.status}</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-teal-400">{scenario.online}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}